import { useEffect, useState } from "react";
import AdminMessageChat from "../../../Components/MessagesForAdmin/AdminMessageChat";
import SidebarMessages from "../../../Components/MessagesForAdmin/SidebarMessages";
import { getMessageDetailsForAdmin } from "../../../apis";
import ChatHeader from "../../../Components/MessagesForAdmin/ChatHeader";
import RowLoader from "../../../Components/UI/RowLoader";
import { useLocation, useNavigate } from "react-router-dom";

const AdminMessages = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarMessagesToggle, setSidebarMessagesToggle] = useState(false);
  const [messageDetailsData, setMessageDetailsData] = useState({});
  const [currentMessageId, setCurrentMessageId] = useState(
    new URLSearchParams(location.search).get("message") || ""
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams();
    if (currentMessageId) params.set("message", currentMessageId);
    navigate({ search: params.toString() });
  }, [currentMessageId, navigate]);

  useEffect(() => {
    if (!currentMessageId) return;
    setIsLoading(true);
    getMessageDetailsForAdmin(currentMessageId)
      .then((response) => {
        setMessageDetailsData(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentMessageId]);

  const {
    createdAt,
    status,
    messageType,
    messageTitle,
    userImage,
    messageDetails,
    messageCategory,
    messageImage,
    messageToImage,
    messageTo,
  } = messageDetailsData;

  return (
    <>
      <div
        onClick={() => setSidebarMessagesToggle(!sidebarMessagesToggle)}
        className="max-xl:tw-flex tw-hidden tw-mb-6 tw-cursor-pointer hover:tw-bg-primaryLight tw-bg-primary tw-text-white tw-items-center tw-p-1 tw-gap-1 tw-rounded-lg tw-max-w-fit tw-px-2"
      >
        <span className="material-icons">chat</span>
        Messages List
      </div>
      <div className="tw-h-full">
        <div className="tw-flex tw-gap-2 tw-h-[90vh] tw-overflow-hidden -tw-my-4 -tw-mx-4 tw-relative">
          {/* Sidebar */}
          <SidebarMessages
            setCurrentMessageId={setCurrentMessageId}
            currentMessageId={currentMessageId}
            sidebarMessagesToggle={sidebarMessagesToggle}
            setSidebarMessagesToggle={setSidebarMessagesToggle}
          />

          {/* Main Chat Area */}
          {currentMessageId ? (
            <div className="tw-flex-1 tw-border tw-rounded-xl tw-overflow-hidden tw-relative">
              {!isLoading ? (
                <>
                  <ChatHeader
                    data={{
                      messageToImage,
                      messageTo,
                      createdAt,
                      status,
                      messageType,
                    }}
                  />
                  <AdminMessageChat
                    currentMessageId={currentMessageId}
                    mainMessageData={{
                      messageTitle,
                      createdAt,
                      userImage,
                      messageDetails,
                      messageCategory,
                      messageImage,
                      userImage,
                    }}
                  />
                </>
              ) : (
                <div className="tw-flex tw-justify-center tw-items-center tw-mt-28">
                  <RowLoader />
                </div>
              )}
            </div>
          ) : (
            <div className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-h-full tw-bg-gradient-to-br tw-from-gray-100 tw-to-gray-200">
              <div className="tw-text-center tw-bg-white tw-rounded-2xl tw-shadow-xl tw-px-8 tw-py-10 tw-max-w-md tw-w-full tw-animate-fadeIn">
                <p className="tw-text-gray-500 tw-mb-4">
                  Select a message from the left sidebar to get started.
                </p>
                <span className="tw-text-gray-400 tw-text-sm">
                  Your messages and replies will appear here.
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AdminMessages;
